module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBold-slnt=0.bd9525f1.ttf";